/*
 * @Author: liyxt
 * @Date: 2019-10-14 11:19:57
 * @LastEditors: wanglongx
 * @LastEditTime: 2020-08-04 09:55:45
 * @Description: file content
 */
/*
* 转过时区的RangePicker
* */
import React, { Component } from 'react';
import DatePicker from 'bee-datepicker';
import moment from 'moment';
import { isArray, isArrowKeyDown, isEmpty, isIE, setElementFocusInIE } from '@platform/api';
import { DongbaToLocalTime, LocalToDongbaTime, isDongba, locale, localeLang, getDatetimeFormat } from '@platform/api';
import { getDateFunNode, getTimeFunctionLabel, getTimeFunctionDisplay, setMultiLang } from './dateFunction';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/en-au';
import { getMultiLang } from '@platform/api';
import { getSysFieldid } from '@platform/api';
import Tooltip from '../Tooltip';

require('bee-datepicker/build/DatePicker.css');

let localeZoneIsDongba = isDongba();

const { RangePicker: OriginRangePicker } = DatePicker;
require('./index.less');

// import 'moment/locale/zh-cn';
// moment.locale('zh-cn');

class RangePicker extends Component {
    constructor(props) {
        super(props);
        this.opened = false;
        this.state = {
            json: {},
            hasCloseBtn: false,
            current: this.getDefaultTime(this.props), //修改format报错问题
        };
    }

    UNSAFE_componentWillMount() {
        let { defaultValue, value } = this.props;
        if (defaultValue || value) {
            // 传空数组问题 add by wanglongx
            if (Object.prototype.toString.call(value).slice(8, -1) === 'Array' && value.length === 0) {
                this.setState({ hasCloseBtn: false })
            } else {
                this.setState({ hasCloseBtn: true });
            }

        }

        let callback = json => {
            this.setState({ json, localeLang }, () => {
                window.addEventListener('mousedown', this.close, false);

                this.getDefaultTime(this.props, () => {
                    console.log(1);
                });
            });
        };
        getMultiLang({ moduleId: ['page_search', 'common'], callback });
    }

    componentDidMount() {
        this.outInput = this.select && this.select.querySelector('input');
        this.outInput.addEventListener('keydown', this.keyDownHandler);
    }

    componentWillUnmount() {
        // 移除document事件
        window.removeEventListener('mousedown', this.close);
        this.outInput.removeEventListener('keydown', this.keyDownHandler);
        this.select = this.outInput = null;
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps, 'jinlai')
        this.getDefaultTime(nextProps);
        if (nextProps.value && !this.state.hasCloseBtn) {
            // 传空数组问题 add by wanglongx
            if (
                Object.prototype.toString.call(nextProps.value).slice(8, -1) === 'Array' &&
				nextProps.value.length === 0
            ) {
                return;
            }
            this.setState({ hasCloseBtn: true });
        }
        if (!nextProps.value) {
            this.setState({ hasCloseBtn: false });
        }
    }

	onChange = v => {
	    let BeijinVal = [];
	    let currentVal = v;

	    if (!isEmpty(v)) {
	        //先检查是不是 时间函数
	        if (!this.timeFunctionHandler(currentVal, BeijinVal)) {
	            // 东八区的时间 转为本地时间
	            if (currentVal && currentVal.length) {
	                let start = moment(`${moment(currentVal[0]).format('YYYY-MM-DD')} 00:00:00`);
	                let end = moment(`${moment(currentVal[1]).format('YYYY-MM-DD')} 23:59:59`);
	                let timer1 = !localeZoneIsDongba
	                    ? LocalToDongbaTime(start, this.props.notconverttimezones).format('YYYY-MM-DD HH:mm:ss')
	                    : start.format('YYYY-MM-DD HH:mm:ss');
	                let timer2 = !localeZoneIsDongba
	                    ? LocalToDongbaTime(end, this.props.notconverttimezones).format('YYYY-MM-DD HH:mm:ss')
	                    : end.format('YYYY-MM-DD HH:mm:ss');
	                BeijinVal = [timer1, timer2];
	            }
	            if (v.length === 2) {
	                this.props.onChange &&
						this.props.onChange(BeijinVal, [
						    `${v[0].format('YYYY-MM-DD')}`,
						    `${v[1].format('YYYY-MM-DD')}`,
						]);
	            }
	        } else {
	            this.props.onChange && this.props.onChange(currentVal, getTimeFunctionDisplay(currentVal));
	        }
	    } else {
	        this.props.onChange && this.props.onChange(null, null);
	    }
	    this.opened = true;
	};

	close = e => {
	    const { onBlur, value } = this.props;
	    // 当在面板里的时候做下判断 -- by bbqin
	    let picerPanel = document.querySelector('.rc-calendar.rc-calendar-range');
	    // 判断当前组件是否被聚焦 有两种情况  情况一 面板弹开  情况二  input 聚焦
	    let inputDom = this.select.querySelector('input');
	    let focused = document.activeElement === inputDom || this.opened;
	    if (
	        focused &&
			this.select &&
			!this.select.contains(e.target) &&
			!(picerPanel && picerPanel.contains(e.target))
	    ) {
	        typeof onBlur === 'function' && onBlur(value);
	        this.opened = false;
	    }
	};

	onSelect = v => {
	    let BeijinVal = [];
	    let currentVal = v;

	    if (v) {
	        //先检查是不是 时间函数
	        if (!this.timeFunctionHandler(currentVal, BeijinVal)) {
	            // 东八区的时间 转为本地时间
	            if (currentVal && currentVal.length) {
	                let start = moment(`${moment(currentVal[0]).format('YYYY-MM-DD')} 00:00:00`);
	                let end = moment(`${moment(currentVal[1]).format('YYYY-MM-DD')} 23:59:59`);
	                let timer1 = !localeZoneIsDongba
	                    ? LocalToDongbaTime(start, this.props.notconverttimezones).format('YYYY-MM-DD HH:mm:ss')
	                    : start.format('YYYY-MM-DD HH:mm:ss');
	                let timer2 = !localeZoneIsDongba
	                    ? LocalToDongbaTime(end, this.props.notconverttimezones).format('YYYY-MM-DD HH:mm:ss')
	                    : end.format('YYYY-MM-DD HH:mm:ss');
	                BeijinVal = [timer1, timer2];
	            }
	            if (v.length === 2) {
	                this.props.onSelect &&
						this.props.onSelect(BeijinVal, [
						    `${v[0].format('YYYY-MM-DD')} 00:00:00`,
						    `${v[1].format('YYYY-MM-DD')} 23:59:59`,
						]);
	            }
	        } else {
	            this.props.onSelect && this.props.onSelect(currentVal, getTimeFunctionDisplay(currentVal));
	        }
	    } else {
	        this.props.onSelect && this.props.onSelect(null, null);
	    }
	};

	// 用来判断和处理时间函数
	timeFunctionHandler = (val, list = []) => {
	    let result = false;
	    if (isArray(val)) {
	        val.forEach(item => {
	            if (typeof item === 'string' && item.indexOf('#') !== -1) {
	                result = true;
	            }
	            result && list.push(item);
	        });
	    }
	    return result;
	};

	// 初始化默认值
	getDefaultTime = props => {
	    let BeijinVal = props.value;
	    let currentVal = [];
	    if (BeijinVal && !this.timeFunctionHandler(BeijinVal)) {
	        // 东八区的时间 转为本地时间
	        if (BeijinVal && BeijinVal.length) {
	            let timer1 = !localeZoneIsDongba ? DongbaToLocalTime(moment(BeijinVal[0]), props.notconverttimezones) : moment(BeijinVal[0]);
	            let timer2 = !localeZoneIsDongba ? DongbaToLocalTime(moment(BeijinVal[1]), props.notconverttimezones) : moment(BeijinVal[1]);
	            currentVal = [timer1, timer2];
	        }
	    } else {
	        currentVal = BeijinVal;
	    }
	    this.setState({ current: BeijinVal ? currentVal : null });
	};

	openCallBack(flag) {
	    this.props.open = flag;
	    this.setState(this.state);
	    // , () => {
	    // open 属性如果支持了 这里就可以去除了
	    // let $panelOpen = document.querySelector('.rc-calendar-range');
	    // let $this = this.select;
	    // let $input = !$panelOpen && $this && $this.parentElement.querySelector('.u-input-group-btn');
	    // $input && $input.click();
	    // });
	    this.opened = flag;
	}

	//添加x按钮，清空输入框的日期 --by liuxis
	clearValue = () => {
	    let { disabled } = this.props;
	    this.setState({
	        hasCloseBtn: false,
	        value: '',
	    });
	    if (disabled !== true) {
	        //编辑态的时候点击才清空显示的日期
	        this.onChange(null);
	    }
	};

	onOpenChange = isOpen => {
	    //控制关闭时重新聚焦
	    this.open = isOpen;
	    if (isOpen === false && this.outInput) {
	        isIE() ? setElementFocusInIE(this.outInput) : this.outInput.focus();
	    }
	};

	keyDownHandler = e => {
	    if (e.keyCode === 13 && this.open !== true) {
	        e.stopPropagation();
	        e.preventDefault();
	        this.props.onEnter && this.props.onEnter({ e });
	    }

	    if (isArrowKeyDown(e) && this.open !== true && !this.props.arrowKeyDownEnable) {
	        e.stopPropagation();
	        e.preventDefault();
	        this.props.hotKeyWithArrow && this.props.hotKeyWithArrow({ e });
	    }
	};

	render() {
	    let {
	        format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
	        showStar,
	        defaultValue,
	        dateInputPlaceholder,
	        value,
	        open,
	        onChange,
	        showTimeFunction,
	        placeholder,
	        tableOpen,
	        disabled,
	        fieldid,
	        dropdownClassName,
	        ...others
	    } = this.props;
	    if (localeLang === 'simpchn') {
	        moment.locale('zh-cn');
	    } else if (localeLang === 'english') {
	        moment.locale('en');
	    } else if (localeLang === 'tradchn') {
	        moment.locale('zh-tw');
	    } else {
	        moment.locale('zh-cn');
	    }
	    let defaultFormat = isArray(format) ? format[0] : format;
	    let finalFormat = getDatetimeFormat(defaultFormat);
	    // 添加了inputShowValue属性
	    let inputShowValue = [];
	    let { current, json, hasCloseBtn } = this.state;
	    let functionValue = current || [];
	    if (value) {
	        inputShowValue = functionValue.map(e => { let localLocale = moment(e); localLocale.locale('en'); return localLocale.format(finalFormat) });
	    }
	    if (this.timeFunctionHandler(current)) {
	        current = '';
	        placeholder = ' ';
	    } else {
	        functionValue = [];
	    }
	    setMultiLang(json);

	    if (getSysFieldid(fieldid)) {
	        dropdownClassName = dropdownClassName ? dropdownClassName + ` fieldid_${fieldid}_calendar` : `fieldid_${fieldid}_calendar`;
	    }

	    return (
	        <div
	            className={`u-form-control-wrapper nc-rangepicker-wrapper ${this.props.className}`}
	            onClick={e => {
	                e.stopPropagation();
	            }}
	            ref={dom => {
	                this.select = dom;
	            }}
	            fieldid={getSysFieldid(fieldid)}
	        >
	            {showStar ? <span className="range-picker-required-tag">*</span> : ''}
	            <OriginRangePicker
	                dropdownClassName={dropdownClassName + ' nc-rangepicker-calendar'}
	                className="nc-input"
	                format={format}
	                //open={open || false}
	                locale={locale}
	                showOk={false}
	                renderIcon={this.props.renderIcon}
	                placeholder={placeholder || json['common-0003'] || '开始 ~ 结束'}
	                defaultValue={current}
	                dateInputPlaceholder={
	                    dateInputPlaceholder || [
	                        `${json['page-search-0039']}(YYYY-MM-DD)`,
	                        `${json['page-search-0040']}(YYYY-MM-DD)`,
	                    ]
	                }
	                inputShowValue={inputShowValue}
	                MultiTZ={true}
	                value={current || []}
	                onChange={this.onChange}
	                showClear={this.props.showClear}
	                disabled={disabled}
	                renderError={() => (
	                    <Tooltip
	                        visible={true}
	                        className="datepicker-tooltip"
	                        placement="top"
	                        overlay={`${json['common-0004']}：${dateInputPlaceholder || 'YYYYMMDD'}`}
	                    >
	                        <span style={{ position: 'absolute', left: '125px' }} />
	                    </Tooltip>
	                )}
	                renderFooter={getDateFunNode.bind(this, functionValue, this.onChange, showTimeFunction, this.props.hiddenFunList, this.props.notconverttimezones)}
	                // renderFooter={() => <button>ssss</button>}
	                {...others}
	                onStartInputBlur={() => {
	                    /**
						 * 待tinper解决问题
						 * v 需要同时返回开始日期 和 结束日期
						 * open属性为什么这样传
						 * onChange事件什么时机执行
						 */
	                    // let newDate = repleAndCheckDate(v);
	                    // let endDate = ""
	                    // if(this.state.current && this.state.current[1]){
	                    // 	endDate = this.state.current[1];
	                    // }
	                    // if(newDate){
	                    // 	let newValue = [moment(newDate), endDate];
	                    // 	//是否还需要转时区
	                    // 	this.setState({
	                    // 		current: newValue
	                    // 	})
	                    // }
	                }}
	                onEndInputBlur={() => {
	                    // let newDate = repleAndCheckDate(v);
	                    // let startDate = ""
	                    // if(this.state.current && this.state.current[1]){
	                    // 	startDate = this.state.current[1];
	                    // }
	                    // if(newDate){
	                    // 	let newValue = [startDate, moment(newDate)];
	                    // 	//是否还需要转时区
	                    // 	this.setState({
	                    // 		current: newValue
	                    // 	})
	                    // }
	                }}
	                onOpenChange={this.onOpenChange}
	            />
	            {hasCloseBtn && (
	                <i
	                    className={"nc-rangepicker-del-i iconfont icon-qingkong" + (disabled ? ' icon-hidden' : '')}
	                    onClick={() => {
	                        this.clearValue();
	                    }}
	                />
	            )}
	            {getTimeFunctionLabel(functionValue, showTimeFunction, this.openCallBack.bind(this))}
	        </div>
	    );
	}
}

RangePicker.defaultProps = {
    showClear: true,
    showClose: false,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};

export default RangePicker;
